import { useLocation } from 'react-router-dom';
import { Typography } from '@mui/material';

// Un "/" o ".." codificado en la dirección (%2F, %2E%2E, %5C) llega decodificado a useParams y, pegado a
// la ruta de la API, cambia el endpoint: /r-accountstatus/..%2F..%2Fusers%2FResetPassword%2F7 terminaba
// en POST api/users/ResetPassword/7 con la sesión de quien abriera el enlace. Ninguna ruta de la app usa
// esos caracteres en sus parámetros (son ids, fechas YYYY-MM-DD o "t"), así que esas direcciones no se dibujan.
export const esRutaInsegura = (pathname) =>
	pathname.split('/').some((segmento) => {
		let valor;
		try {
			valor = decodeURIComponent(segmento);
		} catch {
			return true;
		}
		return valor.includes('/') || valor.includes('\\') || valor === '..' || valor === '.';
	});

const RutaSegura = ({ children }) => {
	const { pathname } = useLocation();

	if (esRutaInsegura(pathname)) {
		return (
			<Typography sx={{ mt: 4, textAlign: 'center' }} color="text.secondary">
				La dirección no es válida.
			</Typography>
		);
	}

	return children;
};

export default RutaSegura;
